// import React from 'react';
import '../styles/Footer.css';


const Footer = () => {
    return ( 
        null
        // <div className="footer">
        //     <h5>Raphael Ehindero @ Copywright 2020 </h5>
        // </div>
     );
}
 
export default Footer;